import React from 'react'
import cx from 'classnames'
import links from 'links'
import { useFt } from 'hooks'
import { constants } from 'helpers'
import { Button } from 'components/inputs'
import { Text } from 'components/dataDisplay'

import HolidayBaseBanner from '../HolidayBaseBanner/HolidayBaseBanner'

import messages from './messages'

// TODO: Styles used in multiple components. Consider moving this banner to composition/banners
import s from './HolidaySeasonBanner.scss'


type HolidaySeasonBannerProps = {
  discount?: number
  className?: string
  position?: number
}

const HolidaySeasonBanner: React.FC<HolidaySeasonBannerProps> = ({ className, discount, position }) => {
  const isGiftHubNotificationEnabled = useFt(constants.features.giftHubNotification)
  const isGiftHubValentinesNotificationMessageEnabled = useFt(constants.features.giftHubValentinesNotificationMessage)

  const notificationMessage = isGiftHubValentinesNotificationMessageEnabled ? messages.valentinesDayNotification : messages.notification
  const holidayMessage = isGiftHubNotificationEnabled ? notificationMessage : messages.defaultTitle

  const message = discount
    ? {
      ...messages.title,
      values: { discount },
    }
    : holidayMessage

  return (
    <HolidayBaseBanner position={position} to={discount ? links.shop.holiday : links.gifts}>
      <div
        className={cx(className, s.banner)}
        data-testid="holidaySeasonBanner"
      >
        <div className="flex h-full items-center justify-center gap-16 px-16">
          <Text
            className="flex-1 text-white"
            message={message}
            style="h8"
          />
          <Button className="px-8" size={38} noPadding title={messages.button} />
        </div>
      </div>
    </HolidayBaseBanner>
  )
}

export default HolidaySeasonBanner
